import { Adapter } from "@/core/models/adapter";

export const ABSORPTION_NONE = null;
export const ABSORPTION_BY_VALUE = "by_value";
export const ABSORPTION_AMOUNT_CONTROLLED_PERCENTAGE = "percentage_amount_controlled";
export const ABSORPTION_AMOUNT_DECLARED_PERCENTAGE = "percentage_amount_declared";

export const CATEGORY_STATUS_ACTIVE = "active";
export class Category {
  constructor() {
    this.id = null;
    this.identifier = null;
    this.label = null;
    this.organizationId = null;
    this.image = null;
    this.description = null;
    this.parentCategory = null;
    this.children = null;
    this.childrenDescription = null;
    this.products = null;
    this.dispatchCircuitRule = null;
    this.numberOfProducts = null;
    this.numberOfPublishedProducts = null;
    this.defaultProductWeight = null;
    this.defaultProductHeight = null;
    this.defaultProductLength = null;
    this.defaultProductWidth = null;
    this.absorptionType = null;
    this.absorptionValue = null;
    this.status = null;
    this.highlightedInstruction = null;
    this.buyerAccountId = null;
  }
}

export class CategoryAdapter extends Adapter {
  static adapt(categoryApi) {
    const category = new Category();
    category.id = categoryApi?.id;
    category.identifier = categoryApi?.identifier;
    category.label = categoryApi?.label;
    category.organizationId = categoryApi?.organizationId;
    category.image = categoryApi?.image;
    category.description = categoryApi?.description;
    category.children = categoryApi?.children;
    category.childrenDescription = categoryApi?.childrenDescription;
    category.products = categoryApi?.products;
    category.dispatchCircuitRule = categoryApi?.dispatchCircuitRule;
    category.numberOfProducts = categoryApi?.numberOfProducts;
    category.numberOfPublishedProducts = categoryApi?.numberOfPublishedProducts;
    category.defaultProductWeight = categoryApi?.defaultProductWeight;
    category.defaultProductHeight = categoryApi?.defaultProductHeight;
    category.defaultProductLength = categoryApi?.defaultProductLength;
    category.defaultProductWidth = categoryApi?.defaultProductWidth;
    category.absorptionType = categoryApi?.absorptionType;
    category.absorptionValue = categoryApi?.absorptionValue;
    if (categoryApi?.parentCategory) {
      category.parentCategory = this.adapt(categoryApi?.parentCategory);
    }
    category.status = categoryApi?.status;
    category.highlightedInstruction = categoryApi?.highlightedInstruction;
    category.buyerAccountId = categoryApi?.buyerAccountId;

    return category;
  }
}
